import { render, staticRenderFns } from "./video-play-v3.vue?vue&type=template&id=695a3f5c&scoped=true"
import script from "./video-play-v3.vue?vue&type=script&lang=ts"
export * from "./video-play-v3.vue?vue&type=script&lang=ts"
import style0 from "./video-play-v3.vue?vue&type=style&index=0&id=695a3f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695a3f5c",
  null
  
)

export default component.exports